import { useCappsLandlordApplicationActionsWebApiHandler_declineApplication } from '@zg-rentals/ts-capps-client-react-query';
import type { DeclineApplicationRequest } from '@zg-rentals/ts-capps-client';

export function useDeclineApplication(options?: {
  onSuccess?: (data: void) => void;
  onError?: (error: unknown) => void;
}) {
  const {
    mutateAsync,
    mutate: _,
    variables: __,
    ...rest
  } = useCappsLandlordApplicationActionsWebApiHandler_declineApplication({
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });

  return {
    ...rest,
    mutateAsync: (data: DeclineApplicationRequest) => {
      return mutateAsync({
        postData: data,
      });
    },
  };
}
